import React, { useEffect, useState } from 'react';
import { useDidMount } from '../../../utils/hooks';
import { licenseTypes } from '../../../utils/variables';
import { getDirection, pexios } from '../../../utils/functions';
import SearchablePicker from '../../master/SearchablePicker';
import Input from '../../master/Input';
import CarSelect from '../../master/CarSelect';
import DatePicker from '../../master/DatePicker';
import Plate from '../../expert/Plate';
import UserDocs from './UserDocs';
import Switch from '../../master/Switch';
import { t } from 'i18next';
import i18n from '../../../i18n';

export default function UserCarInfoEdit({ data, changeData ,step }) {

    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [colors, setColors] = useState([]);
    const [hasBodyInsurance, setHasBodyInsurance] = useState(false);

    useDidMount(() => {
        pexios('api/v2/get_insurance')
            .then(res => {
                setInsuranceCompanies(res.data.data);
            });
        pexios('api/get_color')
            .then(res => {
                setColors(res.data);
            });
    });

    useEffect(() => {
        if (data && data.body_insurance_number) setHasBodyInsurance(true);
    }, [data]);

    return (
        <>
            {step === 0 &&(
                 <div className={`row ${step === 0 ? 'profile-step active' : 'profile-step'}`}>
                    <SearchablePicker
                        label={t('License type')}
                        value={data.license_type || ''}
                        data={licenseTypes}
                        rtl={getDirection(i18n.language) ==='rightToLeft'}
                        onSelect={val => changeData(val, 'license_type')}
                        fixed={true}
                    />
                    <Input
                        label={t('License number')}
                        value={data.license_number}
                        onChange={value => changeData(value, 'license_number')}
                    />
                </div>
            )}
            {step === 1 &&(
                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'? 'text-right' :'text-left'} ${step === 1 ? 'profile-step active' : 'profile-step'}`}>
                    <Plate
                        type={data.plate_type}
                        plate={{
                            plate_iran: data.plate_iran,
                            plate_left: data.plate_left,
                            plate_center: data.plate_center,
                            plate_right: data.plate_right,
                        }}
                        change={(value, name) => changeData(value, name)}
                    />
                    <Input
                        label={t('Chassis number')}
                        value={data.chassis_number}
                        onChange={value => changeData(value, 'chassis_number')}
                    />
                    <Input
                        label={t('Motor number')}
                        value={data.motor_number}
                        onChange={value => changeData(value, 'motor_number')}
                    />
                    <CarSelect
                        data={{
                            carType: data.car_type_id,
                            carBrand: data.car_brand_id,
                            carModel: data.car_model_id,
                        }}
                        onChange={(value, type) => changeData(value, type)}
                        PlateType={data?.plate_type}
                    />
                    <SearchablePicker
                        label={t('Car color')}
                        value={data.car_color_id}
                        data={colors}
                        titleKey='name'
                        valueKey='id'
                        rtl={getDirection(i18n.language) ==='rightToLeft'}
                        onSelect={color => changeData(color, 'car_color_id')}
                    />
                </div>
            )}
            {step === 2 &&(
                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'? 'text-right' :'text-left'} ${step === 2 ? 'profile-step active' : 'profile-step'}`}>
                    <div className='col-12 row align-items-center justify-center'>
                        <label className='pr10 pt10 pl10'>{t('I have body insurance?')}</label>
                        <Switch
                            value={hasBodyInsurance}
                            onChange={(value) =>setHasBodyInsurance(value)}
                        />
                    </div>
                    <Input
                        label={t('Third insurance number')}
                        value={data.third_insurance_number}
                        onChange={value => changeData(value, 'third_insurance_number')}
                    />
                    <SearchablePicker
                        label={t('Third insurance company')}
                        value={data.third_insurance_company}
                        data={insuranceCompanies}
                        titleKey='title'
                        valueKey='id'
                        rtl={getDirection(i18n.language) ==='rightToLeft'}
                        onSelect={val => changeData(val, 'third_insurance_company')}
                        hasIcon
                    />
                    <DatePicker
                        label={t('Third insurance start date')}
                        value={data.third_insurance_start_date}
                        onChange={date => changeData(date, 'third_insurance_start_date')}
                        isInsuranceDate
                    />
                    <DatePicker
                        label={t('Third insurance end date')}
                        value={data.third_insurance_end_date}
                        onChange={date => changeData(date, 'third_insurance_end_date')}
                        isInsuranceDate
                    />
                    {
                        hasBodyInsurance &&
                        <>
                            <Input
                                label={t('Body insurance number')}
                                value={data.body_insurance_number}
                                onChange={value => changeData(value, 'body_insurance_number')}
                            />
                            <SearchablePicker
                                label={t('Body insurance company')}
                                value={data.body_insurance_company}
                                data={insuranceCompanies}
                                titleKey='title'
                                valueKey='id'
                                rtl={getDirection(i18n.language) ==='rightToLeft'}
                                onSelect={val => changeData(val, 'body_insurance_company')}
                                hasIcon
                            />
                            <DatePicker
                                label={t('Body insurance start date')}
                                value={data.body_insurance_start_date}
                                onChange={date => changeData(date, 'body_insurance_start_date')}
                                isInsuranceDate
                            />
                            <DatePicker
                                label={t('Body insurance end date')}
                                value={data.body_insurance_end_date}
                                onChange={date => changeData(date, 'body_insurance_end_date')}
                                isInsuranceDate
                            />
                            </>
                    }
                </div>
            )}
            <>
                <UserDocs
                    data={data}
                    ///
                    step={step}
                    hasBodyInsurance={hasBodyInsurance}
                />
            </>
        </>
    );
}
